import {
  CHANGE_DELIVERY_OPTION_BODY,
  FETCH__LOCATION_IN_BASKET,
  SHOW_CATALOGUS,
  SHOW_HOOFDGROEP,
  SHOW_SUBGROEP,
  STORE_URL,
  UPDATE_FARMER,
  UPDATE_GROUP,
  UPDATE_HOOFDGROUP,
  UPDATE_LOCATION,
  UPDATE_PRODUCTS,
  UPDATE_SEARCHTERM,
  UPDATE_SUBGROUP,
  UPDATE_SUBPRODUCTS,
  UPDATE_SUPPLIER,
  USED_SEARCH_TERM,
} from "./actionTypes";

const initialState = {
  current_location: "", // geef aan wat voor data hier in zit. Ook handig voor code completion and zodat je meteen ziet wat voor data hier in kan zitten
  current_supplier: "",
  current_productgroup: "",
  locations_in_basket: "",
  current_farmer: "All",
  current_hoofdgroup: { name: "", id: "" },
  current_subgroup: "",
  current_subproducts: {},
  used_search_term: false,
  search_term: "",
  current_products: {},
  stored_url: "",
  show_hoofdgroep: true,
  show_subgroep: true,
  show_catalogus: true,
  delivery_option_body: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_LOCATION:
      return {
        ...state,
        current_location: action.payload,
      };
    case UPDATE_SUPPLIER:
      return {
        ...state,
        current_supplier: action.payload,
      };
    case UPDATE_GROUP:
      return {
        ...state,
        current_productgroup: action.payload,
      };
    case UPDATE_FARMER:
      return {
        ...state,
        current_farmer: action.payload,
      };
    case UPDATE_HOOFDGROUP:
      return {
        ...state,
        current_hoofdgroup: action.payload,
      };
    case UPDATE_SUBGROUP:
      return {
        ...state,
        current_subgroup: action.payload,
      };
    case UPDATE_SUBPRODUCTS:
      return {
        ...state,
        current_subproducts: action.payload,
      };
    case USED_SEARCH_TERM:
      return {
        ...state,
        used_search_term: action.payload,
      };
    case FETCH__LOCATION_IN_BASKET:
      return {
        ...state,
        locations_in_basket: action.payload,
      };
    case UPDATE_PRODUCTS:
      return {
        ...state,
        current_products: action.payload,
      };
    case UPDATE_SEARCHTERM:
      return {
        ...state,
        search_term: action.payload,
      };
    case STORE_URL:
      return {
        ...state,
        stored_url: action.payload,
      };
    case SHOW_CATALOGUS:
      return {
        ...state,
        show_catalogus: action.payload,
      };
    case SHOW_HOOFDGROEP:
      return {
        ...state,
        show_hoofdgroep: action.payload,
      };
    case SHOW_SUBGROEP:
      return {
        ...state,
        show_subgroep: action.payload,
      };
    case CHANGE_DELIVERY_OPTION_BODY:
      return {
        ...state,
        delivery_option_body: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}
